export const transformArrayToString = <T extends { name: string }>(
  array: T[],
) => {
  return array.map((item) => item.name).join(", ");
};
